/**
 * 登录页面
 */
export default {
  /**
   * 登录页面 form 框上方文字
   */
  title: 'Welcome to AI Tracking',
  form: {
    username: {
      /**
       * 用户名输入框 无文字时的提示
       */
      placement: 'Enter Username',
      /**
       * 用户名输入不正确时的提示
       */
      error: 'Wrong Username',
    },
    password: {
      /**
       * 密码输入框 无文字时的提示
       */
      placement: 'Enter Password',
      /**
       * 密码输入不正确时的提示
       */
      error: 'Wrong Password',
    },
    captcha: {
      /**
       * 验证码输入框 无文字时的提示
       */
      placement: 'Enter Captcha',
      /**
       * 验证码输入不正确时的提示
       */
      error: 'Wrong Captcha',
    },
    button: {
      /**
       * 登录按钮的文字
       */
      text: 'Login',
    },
  },
  login: 'Login',
  remeber: 'Remember me',
  loginSuccess: 'Successfully loged in and enter the system now',
  /**
   * 网络错误登录上方文字
   */
  loginAgain: 'Please re-login to continue your operation',
  checkCaptcha: 'please check the captcha',
  loginWrong: 'wrong account ID/password',
  loginExpired: 'The account is expired, please contact:bd@jescard.com',
  loginFail: 'Login failed',
};
